import {
  Flex,
  FlexProps,
  Skeleton,
  SkeletonCircle,
  SkeletonProps,
} from '@chakra-ui/react';
import { convertPxToRems } from '~/utils-ts';

export const SkeletonAvatarCell: React.FC<FlexProps> = ({ ...props }) => (
  <Flex alignItems="center" {...props}>
    <SkeletonCircle size={convertPxToRems(32)} marginRight={3} />
    <Skeleton height="1rem" width={convertPxToRems(114)} />
  </Flex>
);

export const SkeletonCell: React.FC<SkeletonProps> = ({ ...props }) => (
  <Flex justifyContent="center" flexDirection="column" height="2rem">
    <Skeleton height="1rem" width="100%" {...props} />
  </Flex>
);
